import { combineReducers } from "@reduxjs/toolkit";
import { addressSlice } from "@/./store/addressSlice";
import { propertySlice } from "@/./store/propertySlice";
import { districtSlice } from "@/./store/districtSlice";

import { appSlice } from "./slice";

const rootReducer = combineReducers({
    address: addressSlice.reducer,
    application: appSlice.reducer,
    property: propertySlice.reducer,
    district: districtSlice.reducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
